import { Button } from '@pfida-finance/ui/components';
import { useNavigate } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { WIDGET_COLORS } from '../constants/colors';

type WidgetButtonVariant = 'primary' | 'danger';

type Props = {
  variant?: WidgetButtonVariant;
  onClick?: () => void;
  to?: string;
  children: ReactNode;
};

const BG: Record<WidgetButtonVariant, string> = {
  primary: WIDGET_COLORS.primary,
  danger: WIDGET_COLORS.red.text,
};

const HOVER_BG: Record<WidgetButtonVariant, string> = {
  primary: WIDGET_COLORS.primaryHover,
  danger: WIDGET_COLORS.red.hover,
};

export function WidgetButton({ variant = 'primary', onClick, to, children }: Props) {
  const navigate = useNavigate();
  const bg = BG[variant];
  const hoverBg = HOVER_BG[variant];

  return (
    <div className="flex justify-center">
      <Button
        variant="ghost"
        className="text-[20px] h-[48px] font-normal"
        style={{ backgroundColor: bg, color: 'white', fontSize: '20px', padding: '8px 16px' }}
        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = hoverBg; }}
        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = bg; }}
        onClick={to ? () => navigate({ to: to as string }) : onClick}
      >
        {children}
      </Button>
    </div>
  );
}
